import TrashIcon from "app/components/Icons/TrashIcon";
import Input from "app/components/Input";
import { Select } from "app/components/Select";
import { Roles } from "app/containers/OnBoarding/data";
import { actions } from "app/containers/OnBoarding/redux/slice";
import { TeamMember } from "app/containers/OnBoarding/types";
import React from "react";
import { useDispatch } from "react-redux";

interface Props {
  index: number;
  member: TeamMember;
}

const AddMember: React.FC<Props> = ({ index, member }) => {
  const dispatch = useDispatch();
  return (
    <div
      key={index}
      className="flex flex-row gap-[16px] w-full relative group "
    >
      <div className=" flex flex-col w-full gap-1 ">
        <div className=" flex flex-row gap-[16px] w-full relative p-[2px] ">
          <label
            htmlFor={`member-${index}`}
            className="text-xs font-medium text-secondary w-full"
          >
            Member
          </label>
          <label
            htmlFor={`role-${index}`}
            className="text-xs font-medium text-secondary w-full"
          >
            Role
          </label>
        </div>
        <div className=" flex flex-row items-center gap-[16px] w-full relative group-hover:bg-gray-400 transition p-[2px] rounded ">
          <Input
            containerClassName="w-full "
            className="group-hover:bg-gray-400 transition"
            id={`member-${index}`}
            value={member.name.value}
            onChange={(e) =>
              dispatch(
                actions.updateTeamMember({
                  index,
                  name: "name",
                  value: e.target.value,
                })
              )
            }
            error={member.name.error}
            placeholder="Enter member email"
          />
          <Select
            unPaddedRole
            options={Roles}
            containerClassName="w-full "
            placeholder="Choose role"
            id={`role-${index}`}
            value={member.role.value}
            error={member.role.error}
            onChange={(value) =>
              dispatch(actions.updateTeamMember({ index, name: "role", value }))
            }
            menuContentClassName=' !max-h-[330px]'
          />
          <div className=" size-5 flex justify-center items-center opacity-0 group-hover:opacity-100 transition">
            {(index === 0 &&
              (member.name.value.length > 0 || member.role.value.length > 0)) ||
            index > 0 ? (
              <button
                onClick={() =>
                  index === 0
                    ? dispatch(actions.clearTeamMember({ index }))
                    : dispatch(actions.removeTeamMember({ index }))
                }
              >
                <TrashIcon />
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMember;
